import type * as core from '../../../../../../../core'

export const query: core.mosaic.Action.Query = {
  selection: {
    '{}': {
      payload: {
        '{}': {
          deletion: {
            '{}': {
              ids: {
                '[]': [
                  {
                    '@$': 'proposalPersonnelId',
                  },
                ],
              },
              modelId: 'ent:!proposal_personnel:!entry',
            },
          },
        },
      },
      operation: 'dms.mutate',
    },
  },
}
